<div class="d-flex align-items-center mb-2">
  <nb-select
    class="ms-2"
    [selected]="15"
    (selectedChange)="changeRecordPerPageLimit($event)"
    placeholder="تعداد نمایش"
  >
    <nb-option [value]="10">10</nb-option>
    <nb-option [value]="15">15</nb-option>
    <nb-option [value]="25">25</nb-option>
    <nb-option [value]="50">50</nb-option>
    <nb-option [value]="100">100</nb-option>
  </nb-select>
</div>
<ng2-smart-table
  [settings]="settings"
  [source]="source"
  (custom)="actions($event)"
></ng2-smart-table>
<div *ngIf="tableLoading" class="loading-backdrop">
  <i class="fal fa-circle-notch fa-spin fa-3x"></i>
</div>
